import {ObjectColor} from "../types"

export const equalColorObjects = (first: ObjectColor, second: ObjectColor): boolean => {
    if (first === second) return true

    for (const prop in first) {
        if (
            ((first as unknown) as Record<string, number>)[prop] !==
            ((second as unknown) as Record<string, number>)[prop]
        )
            return false
    }

    return true
}
